export default __webpack_public_path__ + "static/media/dark_icon128.06a01996.png";